export default "__VITE_ASSET__Yj5U9WiI__"